import { INavData } from '@coreui/angular';
import { Injectable, Component } from '@angular/core'
@Injectable({
  providedIn: 'root'
})
export class global {
  public navItems: INavData[] = JSON.parse(localStorage.getItem("menu"));
  public inicio: string = "loginAdmin";
  cambioMenu(datos) {
    this.navItems = JSON.parse(datos);
  }
}

